import { Prisma } from "@prisma/client";
import { safeComputablePricingValues } from "./pricing.types";

export const getEquipmentArgs = Prisma.validator<Prisma.EquipmentDefaultArgs>()({
  select: {
    id: true,
    name: true,
    quantity: true,
    quantityLeft: true,
    pricing: safeComputablePricingValues,
    deliveryFeePriceHt: true,
    deliveryFeeVatRate: true,
    freeDeliveryThresholdCents: true,
  },
});

export type GetEquipment = Prisma.EquipmentGetPayload<typeof getEquipmentArgs>;

export const adminEventEquipmentRequestArgs =
  Prisma.validator<Prisma.EventEquipmentRequestDefaultArgs>()({
    include: {
      pricing: safeComputablePricingValues,
      deliveryFeePricing: safeComputablePricingValues,
      event: {
        include: {
          organiser: {
            include: {
              admin: {
                include: {
                  picture: true,
                  structure: true,
                },
              },
            },
          },
        },
      },
      buyableItem: {
        include: {
          orderItems: true,
        },
      },
      feeBuyableItem: {
        include: {
          orderItems: true,
        },
      },
      eventEquipmentAllocations: {
        include: {
          eventEquipment: getEquipmentArgs,
        },
      },
    },
  });

export type AdminEventEquipmentRequest = Prisma.EventEquipmentRequestGetPayload<
  typeof adminEventEquipmentRequestArgs
>;

export const organiserEquipmentsArgs = Prisma.validator<Prisma.EquipmentDefaultArgs>()({
  select: {
    id: true,
    name: true,
    pricing: safeComputablePricingValues,
  },
});

export type OrganiserEquipment = Prisma.EquipmentGetPayload<typeof organiserEquipmentsArgs>;

export const organiserEventEquipmentRequestArgs =
  Prisma.validator<Prisma.EventEquipmentRequestDefaultArgs>()({
    include: {
      pricing: safeComputablePricingValues,
      deliveryFeePricing: safeComputablePricingValues,
      eventEquipmentAllocations: {
        include: {
          eventEquipment: organiserEquipmentsArgs,
        },
      },
      buyableItem: {
        include: {
          basketItem: true,
          orderItems: {
            include: {
              order: true,
            },
          },
        },
      },
      feeBuyableItem: {
        include: {
          basketItem: true,
          orderItems: {
            include: {
              order: true,
            },
          },
        },
      },
    },
  });

export type OrganiserEventEquipmentRequest = Prisma.EventEquipmentRequestGetPayload<
  typeof organiserEventEquipmentRequestArgs
>;

export type EquipmentDegressivePriceBody = {
  id?: string;
  minQuantity: number;
  onQuote: boolean;
  discount: {
    id?: string;
    type: "euro";
    value: number;
  };
};

export type UpdateEquipmentPricingBody = {
  priceTTC: number;
  vatRate: number;
  degressivePrices?: EquipmentDegressivePriceBody[];
};

export type UpdateEquipmentDeliveryFeeBody = {
  deliveryFeePriceHt: number;
  deliveryFeeVatRate: number;
  freeDeliveryThresholdCents: number | null;
};
